// API Configuration
// Detect if accessed through prepscholar.com main site (not subdomain)
// If so, use /my-college-chances prefix so main proxy routes correctly
const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
const isMainPrepscholarSite = currentHost === 'www.prepscholar.com' ||
                               currentHost === 'prepscholar.com' ||
                               currentHost === 'staging.prepscholar.com';

// When accessed through main site, prefix with /my-college-chances
// The main proxy routes /my-college-chances/* to Lightsail and strips the prefix
// So /my-college-chances/api/... becomes /api/... on Lightsail
export const API_BASE_URL = isMainPrepscholarSite
  ? '/my-college-chances'
  : (process.env.REACT_APP_API_URL || 'http://localhost:8000');

// Get CSRF token from cookie
export function getCsrfToken() {
  const name = 'csrftoken';
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Fetch wrapper that includes CSRF token
export async function fetchWithCSRF(url, options = {}) {
  const headers = {
    ...options.headers,
  };
  
  // Add CSRF token to headers for POST/PUT/DELETE requests
  if (options.method && options.method !== 'GET' && options.method !== 'HEAD') {
    const token = getCsrfToken();
    if (token) {
      headers['X-CSRFToken'] = token;
    }
  }
  
  return fetch(url, {
    ...options,
    headers,
    credentials: 'include', // Include cookies in request
  });
}

